import { ImageType } from "../challenges/types/common";

export type TaskCollection = {
  id: string;
  name: string;
  banner: ImageType;
  logo: ImageType;
  award: string;
  special: boolean;
  is_active: boolean;
  tasks_count: number;
  total_award: number;
  completed_tasks_count: number;
};

export type Stage = {
  id: string;
  display_value: string;
  value: number;
  award: string;
  order: number;
  awarded: boolean;
};

export type TaskSection = "TASKS" | "SOCIAL";

export type TaskList = {
  id: string;
  multi_stage: boolean;
  name: string;
  premium: boolean;
  coming_soon: boolean;
  description: string | null;
  logo: ImageType;
  award: string;
  is_active: boolean;
  show_in_home: boolean;
  show_in_list: boolean;
  task_type: TaskVariant;
  section: TaskSection;
  story_id: string;
  link: string;
  telegram_chat_id: string;
  target_invite_count: number;
  target_farm_count: string;
  advertisement_id: string;
  user_process: {
    status: TaskStatus;
    completed_at: string;
    user_message: string;
    cur_stage_value: number | null;
  } | null;
  stages: Stage[];
  /** OPTION_TASK only: tier key -> DON for that tier, already premium-adjusted. */
  option_awards?: Record<string, string> | null;
};

export enum TaskVariant {
  GotoLink = "GOTO_LINK",
  ViewStory = "VIEW_STORY",
  TelegramChatJoin = "TELEGRAM_CHAT_JOIN",
  ExternalTask = "EXTERNAL_TASK",
  Keyword = "KEYWORD",
  Ads = "ADS",
  Invites = "INVITES",
  Farm = "FARM",
  OptionTask = "OPTION_TASK",
}

export enum TaskStatus {
  Pending = "PENDING",
  ReadyAward = "READY_AWARD",
  Completed = "COMPLETED",
  Incomplete = "INCOMPLETE",
}

export type TaskStatusResponse = `${TaskStatus}` | "RETRY_LATER";

export type TaskAwardResponse = "ALREADY_COMPLETED" | "COMPLETED" | "NOT_READY";

export type TaskDetail = {
  id: string;
  name: string;
  description: string;
  banner: {
    id: string;
    url: string;
    name: string;
    size: number;
  };
  is_user_awarded: boolean;
  image: ImageType;
  award: string;
  special: boolean;
  is_active: boolean;
  tasks: TaskList[];
  link: string;
  has_tasks: boolean;
  has_education: boolean;
  has_social: boolean;
};

export type InfoDataProps = {
  id: string;
  title: string;
  description: string;
  item: 'result' | 'time'
}

export type Option = {
  id: string;
  title: string;
}